<template>
  <div class="container-form margin-top-30">
    <h4 class="section-name-form">
      Poți semna contractul olograf, direct în caseta de mai jos.
    </h4>
    <div class="row">
      <div class="col-md-12 margin-top-15">
        <signature-canvas
          signature-label="SEMNĂTURA*"
          signature-description="Folosește mouse-ul sau degetul pe ecranul telefonului / tabletei pentru a semna"
          :save-signature="getSignaturePad"
        ></signature-canvas>
        <p class="margin-top-30">
          *Dacă preferi să semnezi contractul în format fizic sau folosind o
          semnătură electronică, apasă butonul „FINALIZEAZĂ”.
        </p>
      </div>
    </div>
    <div class="align-button-form margin-top-30">
      <button-form button-name="FINALIZEAZĂ" :on-click="nextStep"></button-form>
    </div>
  </div>
</template>

<script>
import ButtonForm from "../global/ButtonForm";
import SignatureCanvas from "../global/SignatureCanvas";
import {mapState, mapMutations} from "vuex";
import axios from "axios";

let signaturePad = null;

export default {
  components: {
    ButtonForm,
    SignatureCanvas
  },
  computed: {
    ...mapState({
      formInputs: state => state.formInputs
    })
  },
  methods: {
    ...mapMutations([
      "addFileName",
      "incrementWizardStep"
    ]),
    getSignaturePad: function (object) {
      signaturePad = object;
    },
    nextStep: function () {
      const addFileNameFunc = this.addFileName;
      const incrementWizardStepFunc = this.incrementWizardStep;

      // Log data that's about to be sent
      const postData = {
        formInputs: {
          ...this.formInputs,
          signature: !signaturePad.isEmpty() ? signaturePad.toDataURL() : null
        }
      };
      console.log('Sending data:', postData);

      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        },
        url: "/wp-content/themes/recorder/template-parts/formular/submitForm.php",
        data: postData
      })
        .then(function (response) {
          // Log server's response
          console.log('Server responded with:', response.data);

          if (response.data) {
            addFileNameFunc(response.data.fileName);
            incrementWizardStepFunc();
          }
        })
        .catch(function (error) {
          // Log any errors
          console.error('Error with the request:', error);
        });
    }
  }
};
</script>
